<!-- ── LOADER ─────────────────────────────────────────────── -->
@if(isLoading) {
  <div class="loader-overlay">
    <div class="loader-box">
      <div class="loader-brand">
        <div class="loader-brand-icon">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10zm-2-2H7v-2h10v2zm0-4H7V9h10v2z"/>
          </svg>
        </div>
        <span class="loader-brand-name">Checkout</span>
      </div>
      <div class="loader-spinner">
        <svg viewBox="0 0 50 50">
          <circle cx="25" cy="25" r="20" fill="none" stroke-width="3"/>
        </svg>
      </div>
      <div class="loader-shimmer-group">
        <div class="shimmer shimmer-title"></div>
        <div class="shimmer shimmer-amount"></div>
        <div class="shimmer shimmer-bar"></div>
        <div class="shimmer shimmer-card"></div>
        <div class="shimmer shimmer-card short"></div>
      </div>
      <p class="loader-label">Carregando dados do pedido<span class="loader-dots"><span>.</span><span>.</span><span>.</span></span></p>
    </div>
  </div>
}

<!-- ── ERRO DE CARREGAMENTO ───────────────────────────────── -->
@if(loadError && !isLoading) {
  <div class="error-screen">
    <div class="error-box">
      <div class="error-icon">
        <svg viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke-width="2"/>
          <line x1="12" y1="8" x2="12" y2="12" stroke-width="2.5" stroke-linecap="round"/>
          <circle cx="12" cy="16" r="1" fill="currentColor"/>
        </svg>
      </div>
      <h2>Não foi possível carregar</h2>
      <p>{{ loadErrorMessage }}</p>
      <button (click)="ngOnInit()">Tentar novamente</button>
    </div>
  </div>
}

<!-- ── CHECKOUT ───────────────────────────────────────────── -->
<div class="checkout-wrapper" [class.visible]="!isLoading && !loadError">

  <div class="logo-wrapper">
    <img [src]="branding.logoUrl" [alt]="branding.logoAlt" />
  </div>

  <!-- ── HEADER ─────────────────────────────────────────── -->
  <header class="checkout-header">
    <div class="brand">
      <div class="brand-icon">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10zm-2-2H7v-2h10v2zm0-4H7V9h10v2z"/>
        </svg>
      </div>
      <div>
        <div class="brand-name">Checkout</div>
        <div class="brand-sub">Pagamento Seguro</div>
      </div>
    </div>
    <div class="secure-badge">
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M12 2L4 5v6c0 5.25 3.5 10.15 8 11.5C16.5 21.15 20 16.25 20 11V5l-8-3z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      SSL Criptografado
    </div>
  </header>

  <!-- ── TOTAL CARD ──────────────────────────────────────── -->
  <div class="total-card">
    @if(orderTitle) {
      <div class="total-title">{{ orderTitle }}</div>
    }
    <div class="total-label">Valor total do pedido</div>
    <div class="total-amount">
      <span class="currency">R$</span>{{ fmtBRL(orderTotalSig()) }}
    </div>
    <div class="progress-section">
      <div class="progress-meta">
        <span class="progress-label">Progresso do pagamento</span>
        <span class="progress-values">R$ {{ fmtBRL(paidTotal + inProgressTotal) }} / R$ {{ fmtBRL(orderTotalSig()) }}</span>
      </div>
      <div class="progress-track">
        @if(paidProgressPct > 0) {
          <div class="progress-fill progress-fill--paid" [class.progress-fill--joined]="inProgressPct > 0" [style.width.%]="paidProgressPct">
            <div class="progress-tooltip">
              <strong>Pago</strong>
              <span>R$ {{ fmtBRL(paidTotal) }}</span>
            </div>
          </div>
        }
        @if(inProgressPct > 0) {
          <div class="progress-fill progress-fill--in-progress" [style.left.%]="paidProgressPct" [style.width.%]="inProgressPct">
            <div class="progress-tooltip">
              <strong>Em processamento</strong>
              <span>R$ {{ fmtBRL(inProgressTotal) }}</span>
            </div>
          </div>
        }
      </div>
      <div class="progress-legend">
        <span class="progress-legend__item">
          <span class="progress-legend__dot progress-legend__dot--paid"></span>
          Pago: R$ {{ fmtBRL(paidTotal) }}
        </span>
        <span class="progress-legend__item">
          <span class="progress-legend__dot progress-legend__dot--in-progress"></span>
          Em processamento: R$ {{ fmtBRL(inProgressTotal) }}
        </span>
      </div>
      <div class="remaining-tag" [class.zero]="isComplete" [class.warning]="hasProcessingCoverage">
        @if(hasProcessingCoverage) {
          <ng-container>◌ Pagamento ainda em processamento</ng-container>
        }
        @else if(isComplete) {
          <ng-container>✔ Valor totalmente coberto</ng-container>
        }
        @else {
          <ng-container>↓ R$ {{ fmtBRL(remaining) }} restante</ng-container>
        }
      </div>
    </div>
  </div>

  <!-- ── ADD PAYMENT CARD ────────────────────────────────── -->
  @if(!isFullyCovered) {
    <div class="add-payment-card" [class.active]="true">
      <div class="method-tabs" [style.grid-template-columns]="'repeat(' + availablePaymentMethods.length + ', minmax(0, 1fr))'">
        @if(availablePaymentMethods.includes('pix')) {
        <button class="method-tab" [class.active]="activeMethod === 'pix'" (click)="selectMethod('pix')">
          <span class="method-tab-icon method-tab-icon--pix" aria-hidden="true">
            <img src="img/pix.png" alt="PIX">
          </span>
          PIX
        </button>
        }
        @if(availablePaymentMethods.includes('card')) {
        <button class="method-tab" [class.active]="activeMethod === 'card'" (click)="selectMethod('card')">
          <span class="method-tab-icon">💳</span> Cartão de Crédito
        </button>
        }
        @if(availablePaymentMethods.includes('boleto')) {
        <button class="method-tab" [class.active]="activeMethod === 'boleto'" (click)="selectMethod('boleto')">
          <span class="method-tab-icon method-tab-icon--boleto" aria-hidden="true">
            <img src="img/5393325.png" alt="Boleto">
          </span>
          Boleto
        </button>
        }
      </div>

      <!-- ── PIX Form ──────────────────────────────────────── -->
      @if(activeMethod === 'pix' && availablePaymentMethods.includes('pix')) {
        <div class="payment-form-body">
          <div class="field">
            <label>Valor a pagar</label>
            <div class="value-input-wrap">
              <span class="value-input-prefix">R$</span>
              <input type="text" inputmode="numeric" [value]="pixAmountDisplay" (input)="onPixAmountInput($event)" placeholder="0,00">
            </div>
            <button class="use-remaining" type="button" (click)="useRemaining()">✦ Usar valor restante</button>
          </div>

          @if(pixKey || pixQrImage) {
            <div class="pix-instruction">
              <div class="qr-placeholder">
                @if(pixQrImage) {
                  <img [src]="pixQrImage" alt="QR Code PIX">
                }
              </div>
              <div class="pix-key-wrap">
                <input type="text" [value]="pixKey ?? ''" readonly>
                <button class="copy-btn" type="button" (click)="copyPix()" [disabled]="!pixKey">
                  <svg viewBox="0 0 24 24" fill="none">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke-width="2"/>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke-width="2"/>
                  </svg>
                  Copiar
                </button>
              </div>
              <p class="pix-note">Escaneie o QR Code ou copie a chave PIX.<br>O pagamento é confirmado instantaneamente.</p>
            </div>
            <button class="btn-add" type="button" (click)="addPayment()" [disabled]="isPixSubmitting">
              <svg viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12"/></svg>
              Confirmar PIX
            </button>
            <button class="btn-secondary-action" type="button" (click)="newPixPayment()" [disabled]="isPixSubmitting">
              Novo pagamento
            </button>
          }
          @else {
            <button class="btn-add" type="button" (click)="generateQRCode()" [disabled]="isPixSubmitting">
              @if(isPixSubmitting) {
                <span class="btn-add__spinner" aria-hidden="true"></span>
                Gerando QR Code...
              }
              @else {
                <svg viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12"/></svg>
                Gerar Código PIX
              }
            </button>
          }
        </div>
      }

      <!-- ── Card Form ─────────────────────────────────────── -->
      @if(activeMethod === 'card' && availablePaymentMethods.includes('card')) {
        <div class="payment-form-body">

          <!-- CARD VISUAL 3D -->
          <div class="card-scene" [class.flipped]="cardFocusField === 'cvv'">
            <div class="card-3d">

              <!-- FRENTE -->
              <div class="card-face card-front">
                <div class="card-bg-pattern"></div>
                <div class="card-front-top">
                  <div class="card-chip">
                    <svg viewBox="0 0 34 26" fill="none">
                      <rect x="1" y="1" width="32" height="24" rx="3" fill="#d4a843" stroke="#b8922e" stroke-width="1"/>
                      <rect x="1" y="9"  width="32" height="8"  fill="#c9982d"/>
                      <line x1="12" y1="1"  x2="12" y2="25" stroke="#b8922e" stroke-width="0.8"/>
                      <line x1="22" y1="1"  x2="22" y2="25" stroke="#b8922e" stroke-width="0.8"/>
                      <line x1="1"  y1="9"  x2="33" y2="9"  stroke="#b8922e" stroke-width="0.8"/>
                      <line x1="1"  y1="17" x2="33" y2="17" stroke="#b8922e" stroke-width="0.8"/>
                    </svg>
                  </div>
                  <div class="card-brand-logo">
                    @if(cardBrand === 'visa') {
                      <svg class="brand-svg brand-visa" viewBox="0 0 80 28">
                        <text x="0" y="22" font-family="Arial Black,sans-serif" font-size="26" font-weight="900" fill="white" letter-spacing="-1">VISA</text>
                      </svg>
                    }
                    @if(cardBrand === 'mastercard') {
                      <svg class="brand-svg brand-mastercard" viewBox="0 0 56 34">
                        <circle cx="20" cy="17" r="15" fill="#eb001b"/>
                        <circle cx="36" cy="17" r="15" fill="#f79e1b"/>
                        <path d="M28 5.5a15 15 0 0 1 0 23A15 15 0 0 1 28 5.5z" fill="#ff5f00"/>
                      </svg>
                    }
                    @if(cardBrand === 'amex') {
                      <svg class="brand-svg brand-amex" viewBox="0 0 72 28">
                        <text x="0" y="21" font-family="Arial Black,sans-serif" font-size="16" font-weight="900" fill="white" letter-spacing="2">AMEX</text>
                      </svg>
                    }
                    @if(cardBrand === 'elo') {
                      <svg class="brand-svg brand-elo" viewBox="0 0 56 28">
                        <text x="0" y="22" font-family="Arial Black,sans-serif" font-size="22" font-weight="900" fill="#ffcb00" letter-spacing="1">elo</text>
                      </svg>
                    }
                    @if(cardBrand === 'hipercard') {
                      <svg class="brand-svg brand-hipercard" viewBox="0 0 100 28">
                        <text x="0" y="20" font-family="Arial Black,sans-serif" font-size="14" font-weight="900" fill="white" letter-spacing="0.5">hipercard</text>
                      </svg>
                    }
                    @if(cardBrand === 'unknown') {
                      <svg class="brand-svg brand-unknown" viewBox="0 0 44 30">
                        <rect x="2" y="2" width="40" height="26" rx="4" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="2"/>
                        <rect x="2" y="11" width="40" height="8" fill="rgba(255,255,255,0.15)"/>
                      </svg>
                    }
                  </div>
                </div>

                <div class="card-number-display">
                  <span class="card-digit-group" [class.active]="cardFocusField === 'number'">{{ cardNumberGroups[0] }}</span>
                  <span class="card-digit-group" [class.active]="cardFocusField === 'number'">{{ cardNumberGroups[1] }}</span>
                  <span class="card-digit-group" [class.active]="cardFocusField === 'number'">{{ cardNumberGroups[2] }}</span>
                  <span class="card-digit-group" [class.active]="cardFocusField === 'number'">{{ cardNumberGroups[3] }}</span>
                </div>

                <div class="card-front-bottom">
                  <div class="card-holder-wrap">
                    <span class="card-meta-label">Titular</span>
                    <span class="card-holder-name" [class.active]="cardFocusField === 'name'">
                      {{ cardName || 'NOME COMPLETO' }}
                    </span>
                  </div>
                  <div class="card-expiry-wrap">
                    <span class="card-meta-label">Validade</span>
                    <span class="card-expiry-val" [class.active]="cardFocusField === 'expiry'">
                      {{ cardExpiry || 'MM/AA' }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- VERSO -->
              <div class="card-face card-back">
                <div class="card-bg-pattern"></div>
                <div class="card-magstripe"></div>
                <div class="card-signature-area">
                  <div class="card-signature-lines">
                    <div></div><div></div><div></div><div></div>
                  </div>
                  <div class="card-cvv-box" [class.active]="cardFocusField === 'cvv'">
                    {{ cardCvv || (cardBrand === 'amex' ? '••••' : '•••') }}
                  </div>
                </div>
                <p class="card-back-hint">Código de segurança (CVV)</p>
              </div>

            </div>
          </div>
          <!-- /CARD VISUAL -->

          <div class="field">
            <label>Número do cartão</label>
            <input type="text" placeholder="0000 0000 0000 0000" maxlength="19" inputmode="numeric"
              [ngModel]="cardNumber" (input)="onCardNumberInput($event)"
              (focus)="cardFocusField = 'number'" (blur)="cardFocusField = null"/>
          </div>
          <div class="field">
            <label>Nome no cartão</label>
            <input class="card-name-input" type="text" [ngModel]="cardName" (input)="onCardNameInput($event)" placeholder="NOME COMPLETO"
              (focus)="cardFocusField = 'name'" (blur)="cardFocusField = null"/>
          </div>
          <div class="field">
            <label>CPF/CNPJ</label>
            <input type="text" [ngModel]="cardDocument" (input)="onCardDocumentInput($event)" placeholder="000.000.000-00"
              inputmode="numeric"/>
          </div>
          <div class="field-row">
            <div class="field">
              <label>Validade</label>
              <input type="text" [ngModel]="cardExpiry" (input)="onCardExpiryInput($event)"
                placeholder="MM/AA" maxlength="5" inputmode="numeric"
                (focus)="cardFocusField = 'expiry'" (blur)="cardFocusField = null"/>
            </div>
            <div class="field">
              <label>CVV</label>
              <input type="text" [ngModel]="cardCvv" (input)="onCardCvvInput($event)" [placeholder]="cardCvvPlaceholder" [maxlength]="cardCvvMaxLength" inputmode="numeric"
                (focus)="cardFocusField = 'cvv'" (blur)="cardFocusField = null"/>
            </div>
          </div>
          <div class="field-row">
            <div class="field">
              <label>Valor a pagar</label>
              <div class="value-input-wrap">
                <span class="value-input-prefix">R$</span>
                <input type="text" inputmode="numeric" [value]="cardAmountDisplay"
                  (input)="onCardAmountInput($event)" placeholder="0,00"/>
              </div>
              <button class="use-remaining" type="button" (click)="useRemaining()">✦ Usar valor restante</button>
            </div>
            <div class="field field--installments">
              <label>Parcelas</label>
              <select [(ngModel)]="cardInstallments" (ngModelChange)="onCardInstallmentsChange($event)">
                @for(option of cardInstallmentOptions(); track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
              @if(selectedCardInstallmentOption(); as selectedOption) {
                <div class="installment-helper">
                  <div class="installment-helper__row">
                    <span class="installment-helper__label">Total com taxa</span>
                    <strong class="installment-helper__value">{{ selectedOption.totalLabel }}</strong>
                  </div>
                  <div class="installment-helper__row">
                    <span class="installment-helper__label">Valor da taxa</span>
                    <strong class="installment-helper__value">{{ selectedOption.feeLabel }}</strong>
                  </div>
                </div>
              }
            </div>
          </div>
          <button class="btn-add" type="button" (click)="addPayment()" [disabled]="isCardSubmitting">
            @if(isCardSubmitting) {
              <span class="btn-add__spinner" aria-hidden="true"></span>
              Confirmando...
            }
            @else {
              <svg viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12"/></svg>
              Confirmar Cartão
            }
          </button>
        </div>
      }

      <!-- ── Boleto Form ───────────────────────────────────── -->
      @if(activeMethod === 'boleto' && availablePaymentMethods.includes('boleto')) {
        <div class="payment-form-body">
          <div class="field">
            <label>Valor a pagar</label>
            <div class="value-input-wrap">
              <span class="value-input-prefix">R$</span>
              <input #boletoAmountInput type="text" inputmode="numeric" [value]="boletoAmountDisplay"
                (input)="onBoletoAmountInput($event)"
                placeholder="0,00"/>
            </div>
            <button class="use-remaining" type="button" (click)="useRemaining()">✦ Usar valor restante</button>
          </div>

          @if(boletoCode || boletoBarcode) {
            <div class="boleto-instruction">
              <div class="boleto-slip">
                <div class="boleto-slip__top">
                  <span>Boleto bancário</span>
                  <strong>Vencimento: {{ boletoDueDate }}</strong>
                </div>
                <div class="boleto-barcode" aria-hidden="true">
                  <svg #boletoBarcodeSvg></svg>
                </div>
                <div class="boleto-code-wrap">
                  <input type="text" [value]="boletoCode ?? boletoBarcode ?? ''" readonly>
                  <button class="copy-btn" type="button" (click)="copyBoleto()" [disabled]="!boletoCode && !boletoBarcode">
                    <svg viewBox="0 0 24 24" fill="none">
                      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke-width="2"/>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke-width="2"/>
                    </svg>
                    Copiar
                  </button>
                </div>
                @if(boletoPixKey || boletoPixQrImage) {
                  <div class="boleto-pix-divider">Este boleto possui PIX integrado</div>
                  <button class="copy-btn copy-btn--secondary" type="button" (click)="reopenPixQr('boleto')" [disabled]="!boletoPixKey && !boletoPixQrImage">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M4 4h6v6H4z"/>
                      <path d="M14 4h6v6h-6z"/>
                      <path d="M4 14h6v6H4z"/>
                      <path d="M15 15h1"/>
                      <path d="M15 19h1"/>
                      <path d="M19 15h1"/>
                      <path d="M17 17h1"/>
                      <path d="M19 19h1"/>
                    </svg>
                    Abrir QR PIX
                  </button>
                }
                <p class="boleto-note">Pague a linha digitável no banco, app ou lotérica. A compensação pode levar até 3 dias úteis.</p>
              </div>
            </div>
            <button class="btn-add" type="button" (click)="addPayment()" [disabled]="isBoletoSubmitting">
              @if(isBoletoSubmitting) {
                <span class="btn-add__spinner" aria-hidden="true"></span>
                Confirmando...
              }
              @else {
                <svg viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12"/></svg>
                Confirmar Boleto
              }
            </button>
            <button class="btn-secondary-action" type="button" (click)="newBoletoPayment(boletoAmountInput)" [disabled]="isBoletoSubmitting">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 12a8 8 0 0 1 13.66-5.66"/>
                <polyline points="18 3 18 8 13 8"/>
                <path d="M20 12a8 8 0 0 1-13.66 5.66"/>
                <polyline points="6 21 6 16 11 16"/>
              </svg>
              Novo pagamento
            </button>
          }
          @else {
            <button class="btn-add" type="button" (click)="generateBoleto()" [disabled]="isBoletoSubmitting">
              @if(isBoletoSubmitting) {
                <span class="btn-add__spinner" aria-hidden="true"></span>
                Gerando boleto...
              }
              @else {
                <svg viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12"/></svg>
                Gerar Boleto
              }
            </button>
          }
        </div>
      }
    </div>
  }

  <!-- ── PAYMENTS LIST ───────────────────────────────────── -->
  @if(payments().length > 0 || isFullyCovered) {
    <section class="payments-section">
      @if(payments().length > 0) {
        <div class="payments-section__header">
          <div class="section-title">Recebimentos processados</div>
          @if(!isComplete) {
            <button class="payments-refresh" type="button" (click)="refreshPayments()" [disabled]="isRefreshingPayments">
              @if(isRefreshingPayments) {
                <span class="btn-add__spinner" aria-hidden="true"></span>
                Atualizando...
              }
              @else {
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M21 12a9 9 0 1 1-2.64-6.36"/>
                  <polyline points="21 3 21 9 15 9"/>
                </svg>
                {{ hasRefreshablePayments ? 'Atualizar status' : 'Atualizar lista' }}
              }
            </button>
          }
        </div>
      }
      @for (p of payments(); track $index; let i = $index) {
        <div class="payment-item">
          <div class="payment-method-icon" [class.pix]="p.method === 'pix'" [class.card]="p.method === 'card'" [class.boleto]="p.method === 'boleto'">
            @if(p.method === 'pix') {
              <img class="payment-method-icon__img" src="img/pix.png" alt="PIX">
            }
            @else if(p.method === 'boleto') {
              <img class="payment-method-icon__img" src="img/5393325.png" alt="Boleto">
            }
            @else {
              {{ '💳' }}
            }
          </div>
          <div class="payment-info">
            <div class="payment-method-name">{{ p.method === 'pix' ? 'PIX' : p.method === 'card' ? 'Cartão de Crédito' : 'Boleto Bancário' }}</div>
            <div class="payment-method-detail">
              @if(p.method === 'pix') { <ng-container>Pagamento instantâneo</ng-container> }
              @if(p.method === 'card') { <ng-container>**** {{ p.lastFour }} · {{ p.installments }}x</ng-container> }
              @if(p.method === 'boleto') { <ng-container>Linha digitável gerada</ng-container> }
            </div>
            @if(p.message) {
              <div class="payment-status-message" [class]="getPaymentMessageClass(p)">{{ p.message }}</div>
            }
          </div>
          <div class="payment-meta">
            @if(p.statusDescription) {
              <span class="payment-status-chip" [class.success]="getPaymentStatusTone(p) === 'success'" [class.warning]="getPaymentStatusTone(p) === 'warning'" [class.danger]="getPaymentStatusTone(p) === 'danger'" [class.neutral]="getPaymentStatusTone(p) === 'neutral'">
                {{ getPaymentStatusLabel(p) }}
              </span>
            }
            <div class="payment-amount-chip" [class]="getPaymentAmountChipClass(p)">
              {{ getPaymentAmountPrefix(p) }}R$ {{ fmtBRL(p.amount) }}
            </div>
            @if(p.feeLabel) {
              <div class="payment-fee-label">{{ p.feeLabel }}</div>
            }
          </div>
          <div class="payment-actions">
            @if(p.method === 'pix') {
              <button class="payment-action" type="button" title="Abrir QR Code" (click)="reopenPixQr('pix', p)">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M4 4h6v6H4z"/>
                  <path d="M14 4h6v6h-6z"/>
                  <path d="M4 14h6v6H4z"/>
                  <path d="M15 15h1"/>
                  <path d="M15 19h1"/>
                  <path d="M19 15h1"/>
                  <path d="M17 17h1"/>
                  <path d="M19 19h1"/>
                </svg>
              </button>
            }
            @else if(canOpenBoletoDetails(p)) {
              <button class="payment-action" type="button" title="Visualizar boleto" (click)="openBoletoDetails(p)" [disabled]="downloadingBoletoSeq === p.seq">
                @if(downloadingBoletoSeq === p.seq) {
                  <span class="payment-action__spinner" aria-hidden="true"></span>
                }
                @else {
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M12 3v12"/>
                    <polyline points="7 10 12 15 17 10"/>
                    <path d="M5 21h14"/>
                  </svg>
                }
              </button>
            }
          </div>
        </div>
      }
      @if(hasProcessingCoverage) {
        <div class="completed-banner completed-banner--processing">
          <div class="completed-icon">
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="8"/>
              <path d="M12 8v4l2.5 2.5"/>
            </svg>
          </div>
          <div class="completed-text">
            <div class="title">Pagamento em processamento</div>
            <div class="sub">O valor do pedido já foi coberto, mas ainda aguardamos a confirmação do(s) pagamento(s).</div>
          </div>
        </div>
      }
      @else if(isComplete) {
        <div class="completed-banner">
          <div class="completed-icon">
            <svg viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <div class="completed-text">
            <div class="title">Pagamento completo!</div>
            <div class="sub">Todos os valores foram cobertos.</div>
          </div>
        </div>
      }
    </section>
  }

  <!-- ── FOOTER ──────────────────────────────────────────── -->
  <footer class="checkout-footer">
    <div class="footer-item">
      <svg viewBox="0 0 24 24" fill="none">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke-width="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke-width="2"/>
      </svg>
      Seguro e criptografado
    </div>
    <div class="footer-dot"></div>
    <div class="footer-item">
      <svg viewBox="0 0 24 24" fill="none">
        <path d="M12 2L4 5v6c0 5.25 3.5 10.15 8 11.5C16.5 21.15 20 16.25 20 11V5l-8-3z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      PCI DSS Compliant
    </div>
    @if(requestCode) {
      <div class="footer-dot"></div>
      <div class="footer-item">
        <svg viewBox="0 0 24 24" fill="none">
          <rect x="5" y="11" width="14" height="10" rx="2" ry="2" stroke-width="2"/>
          <path d="M8 11V8a4 4 0 1 1 8 0v3" stroke-width="2" stroke-linecap="round"/>
          <circle cx="12" cy="16" r="1.2" stroke-width="1.8"/>
          <path d="M12 17.2V19" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        {{ requestCode }}
      </div>
    }
  </footer>
</div>

@if(paymentAssetModalOpenSig()) {
  <div class="asset-modal-backdrop" (click)="closePaymentAssetModal()">
    <div class="asset-modal" [class.asset-modal--boleto]="paymentAssetModalHasBoletoDataSig()" (click)="$event.stopPropagation()">
      <button class="asset-modal__close" type="button" (click)="closePaymentAssetModal()" aria-label="Fechar">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M6 6l12 12"/>
          <path d="M18 6L6 18"/>
        </svg>
      </button>
      <div class="asset-modal__title">{{ paymentAssetModalSig().title }}</div>

      @if(paymentAssetModalSig().kind === 'boleto') {
        <div class="asset-modal__content">
          @if(paymentAssetModalSig().boletoBarcode || paymentAssetModalSig().primaryCode) {
            <div class="asset-modal__panel">
              <div class="asset-modal__section-label">Código de barras</div>
              <div class="asset-modal__barcode" aria-hidden="true">
                <svg #assetModalBoletoBarcodeSvg></svg>
              </div>
              @if(paymentAssetModalSig().primaryCode) {
                <div class="asset-modal__code">
                  <label>{{ paymentAssetModalSig().primaryCodeLabel }}</label>
                  <div class="asset-modal__code-row">
                    <input type="text" [value]="paymentAssetModalSig().primaryCode" readonly>
                    <button class="copy-btn" type="button" (click)="copyPaymentAssetCode(paymentAssetModalSig().primaryCode, 'Código do boleto copiado!')">
                      <svg viewBox="0 0 24 24" fill="none">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke-width="2"/>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke-width="2"/>
                      </svg>
                      Copiar
                    </button>
                  </div>
                </div>
              }
            </div>
          }

          @if(paymentAssetModalSig().qrImage || paymentAssetModalSig().pixCode) {
            <div class="asset-modal__panel asset-modal__panel--pix">
              <div class="asset-modal__section-label">PIX do boleto</div>
              @if(paymentAssetModalSig().qrImage) {
                <div class="asset-modal__qr">
                  <img [src]="paymentAssetModalSig().qrImage" alt="QR Code PIX do boleto">
                </div>
              }
              @if(paymentAssetModalSig().pixCode) {
                <div class="asset-modal__code">
                  <label>PIX copia e cola</label>
                  <div class="asset-modal__code-row">
                    <input type="text" [value]="paymentAssetModalSig().pixCode" readonly>
                    <button class="copy-btn" type="button" (click)="copyPaymentAssetCode(paymentAssetModalSig().pixCode, 'Código PIX copiado!')">
                      <svg viewBox="0 0 24 24" fill="none">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke-width="2"/>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke-width="2"/>
                      </svg>
                      Copiar
                    </button>
                  </div>
                </div>
              }
            </div>
          }

          @if(paymentAssetModalSig().pdfBase64) {
            <button class="btn-add asset-modal__download" type="button" (click)="downloadBoletoPdfFromModal()">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 3v12"/>
                <polyline points="7 10 12 15 17 10"/>
                <path d="M5 21h14"/>
              </svg>
              Baixar PDF do boleto
            </button>
          }
        </div>
      }
      @else if(paymentAssetModalSig().primaryCode || paymentAssetModalSig().qrImage) {
        @if(paymentAssetModalSig().qrImage) {
          <div class="asset-modal__qr">
            <img [src]="paymentAssetModalSig().qrImage" alt="QR Code">
          </div>
        }
        @if(paymentAssetModalSig().primaryCode) {
          <div class="asset-modal__code">
            <label>{{ paymentAssetModalSig().primaryCodeLabel }}</label>
            <div class="asset-modal__code-row">
              <input type="text" [value]="paymentAssetModalSig().primaryCode" readonly>
              <button class="copy-btn" type="button" (click)="copyPaymentAssetCode(paymentAssetModalSig().primaryCode)">
                <svg viewBox="0 0 24 24" fill="none">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke-width="2"/>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke-width="2"/>
                </svg>
                Copiar
              </button>
            </div>
          </div>
        }
      }
    </div>
  </div>
}

<!-- ── TOAST ───────────────────────────────────────────── -->
<div class="toast" [class.show]="toastVisible">
  <div class="toast-dot" [class.error]="toastError"></div>
  <span>{{ toastMsg }}</span>
</div>
